import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterArray'
})
export class FilterArrayPipe implements PipeTransform {

  /**
   * Accese a la propiedad y retorna el valor total de la suma
   * @param array el paquete acumulado de los objetos
   * @param value valor a comparar para el filtro
   * @param propiedad a acceder para reducir los valores
   * @returns el valor total de la suma
   */
  transform = (array: Array<any>, value: any, property: string): Array<any> =>
    array.filter(p => p[property] === value);

}
